import { Wrapper } from '@american-autonomy/ag-ui';

import DetailsViewCardHeaderDropdown from 'components/DetailsViewCardHeaderDropdown';
import DetailsViewCardHeaderDropdownMenuItem from 'components/DetailsViewCardHeaderDropdownMenuItem';
import Grid from 'components/Grid';
import AccountIcon from 'components/icons/AccountIcon';
import ApplicationsIcon from 'components/icons/ApplicationsIcon';
import BatteryIcon from 'components/icons/BatteryIcon';
import BoundaryIcon from 'components/icons/BoundaryIcon';
import DroneIcon from 'components/icons/DroneIcon';
import FarmsIcon from 'components/icons/FarmsIcon';
import FieldsIcon from 'components/icons/FieldsIcon';
import CaptionText from 'components/text/CaptionText';
import HeroTitleText from 'components/text/HeroTitleText';
import PageTitleText from 'components/text/PageTitleText';

import DetailsViewCardHeaderSkeleton from './components/Skeleton';
import { TEST_ID } from './constants';
import type { DetailType, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DETAIL_TYPE_ICON: Partial<Record<DetailType, FunctionComponent>> = {
    application: ApplicationsIcon,
    battery: BatteryIcon,
    boundary: BoundaryIcon,
    client: AccountIcon,
    drone: DroneIcon,
    farm: FarmsIcon,
    field: FieldsIcon,
    user: AccountIcon
};

const DetailsViewCardHeader: FunctionComponent<Props> = ({
    className = '',
    detailType,
    isDisabled = false,
    isLoading = true,
    items,
    name,
    testId = TEST_ID
}) => {
    if (isLoading) {
        return (
            <Grid className={`${className} ${styles.detailsViewCardHeader}`} testId={testId}>
                <DetailsViewCardHeaderSkeleton />
            </Grid>
        );
    }

    const Icon = detailType ? DETAIL_TYPE_ICON[detailType] : null;

    return (
        <Grid className={`${className} ${styles.detailsViewCardHeader}`} testId={testId}>
            <Wrapper className={styles.avatarWrapper}>
                {Icon ? (
                    <Icon />
                ) : (
                    <HeroTitleText className={styles.initialText} text={name?.charAt(0)} />
                )}
            </Wrapper>

            <Wrapper className={styles.textWrapper}>
                <CaptionText className={styles.detailTypeText}>{detailType}</CaptionText>

                <PageTitleText className={styles.pageTitleText}>{name}</PageTitleText>
            </Wrapper>

            {items.length > 0 && (
                <DetailsViewCardHeaderDropdown isDisabled={isDisabled}>
                    {items.map(({ onClick, text }) => (
                        <DetailsViewCardHeaderDropdownMenuItem
                            key={text}
                            onClick={onClick}
                            text={text}
                        />
                    ))}
                </DetailsViewCardHeaderDropdown>
            )}
        </Grid>
    );
};

export default DetailsViewCardHeader;
